var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlertIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M29.5218 23.1668L18.055 3.30578C17.4174 2.2014 16.2753 1.54199 15 1.54199C13.7247 1.54199 12.5826 2.2014 11.945 3.30578L0.478256 23.1667C-0.159419 24.2712 -0.159419 25.5899 0.478256 26.6944C1.11593 27.7988 2.25792 28.4582 3.53327 28.4582H26.4667C27.742 28.4582 28.884 27.7987 29.5218 26.6944C30.1594 25.5899 30.1594 24.2712 29.5218 23.1668ZM27.9996 25.8156C27.6796 26.3698 27.1066 26.7006 26.4667 26.7006H3.53327C2.89331 26.7006 2.32026 26.3698 2.00034 25.8156C1.68042 25.2615 1.68042 24.5998 2.00034 24.0456L13.4672 4.18462C13.7871 3.63045 14.3601 3.29963 15 3.29963C15.6399 3.29963 16.213 3.63045 16.5329 4.18462L27.9997 24.0456C28.3195 24.5998 28.3195 25.2615 27.9996 25.8156Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8787 10.313H14.1211V19.101H15.8787V10.313Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9999 20.8586C14.3538 20.8586 13.8281 21.3843 13.8281 22.0304C13.8281 22.6765 14.3538 23.2022 14.9999 23.2022C15.6459 23.2022 16.1716 22.6765 16.1716 22.0304C16.1716 21.3843 15.646 20.8586 14.9999 20.8586Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertIcon);
export default __webpack_public_path__ + "static/media/AlertIcon.efeab337.svg";
export { ForwardRef as ReactComponent };